/**
 * @license lucide v0.469.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */

import defaultAttributes from '../defaultAttributes.js';

const ChartNoAxesGantt = [
  "svg",
  defaultAttributes,
  [
    ["path", { d: "M8 6h10" }],
    ["path", { d: "M6 12h9" }],
    ["path", { d: "M11 18h7" }]
  ]
];

export { ChartNoAxesGantt as default };
//# sourceMappingURL=chart-no-axes-gantt.js.map
